/* eslint-disable */
/*! mars 2019-11-21 11:11:20 */
import jQuery from "jquery";
import $ from "jquery";
$(document).ready(function (){  
(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
/**
 * cookie操作<br>
 * 需要注意的是Mar的cookie都会写到一级域中<br>
 * version 1.0.1.20170407<br>
 * author vk <vk.xiang@vipshop.com><br>
 * @module COMMON
 * @class Mar.Cookie
 */
Mar.Cookie = {
    /**
     * 获取cookie
     * @method get cookie名
     * @param key
     */
    'get': function (key) {
        var cookies = document.cookie ? document.cookie.split(';') : [];
        for (var i = 0; i < cookies.length; i++) {
            var parts = $.trim(cookies[i]).split('=');
            var name = parts[0];
            var cookie = unescape(parts[1]);
            if (key === name) {
                return cookie;
            }
        }
        return;
    },
    /**
     * 获取所有cookie
     * @returns {object} cookie键值对
     */
    'getAll': function() {
        var kv = {};
        var cookies = document.cookie ? document.cookie.split(';') : [];
        for (var i = 0; i < cookies.length; i++) {
            var parts = $.trim(cookies[i]).split('=');
            var name = parts[0];
            var cookie = unescape(parts[1]);
            kv[name] = cookie;
        }
        return kv;
    },
    /**
     * 设置cookie
     * @param key cookie名
     * @param value cookie值
     * @param day cookie的生命周期（单位：天）
     */
    'set': function (key, value, day) {
        var domain = Mar.Util.getDomain();
        if (day === 0) {
            document.cookie = key + '=' + escape(value) + ';path=/;domain=.' + domain ;
        } else {
            var date = new Date();
            date.setTime(date.getTime() + (day * 24 * 3600 * 1000));
            document.cookie = key + '=' + escape(value) + ';expires=' + date.toGMTString() + ';path=/;domain=.' + domain;//domain
        }
    },
    /**
     * 删除cookie
     * @param key cookie名
     */
    'del': function (key) {
        var domain = Mar.Util.getDomain();
        document.cookie = key + '=; expires=Mon, 26 Jul 1997 05:00:00 GMT; path=/;' + (domain ? 'domain=' + domain : '');
    }
};

},{}],2:[function(require,module,exports){

(function () {
    if(window.Mar) return;
    // 为计算探索号加载时间 而标记的起始时间
    window.T0 = (new Date()).getTime();

    // 定义Mar类(主对象)
    window.Mar = function () {
    };

    // *********** 通用函数 ************


    // 对象字符串化
    Mar.stringify = function (obj) {
        if (window.JSON && window.JSON.stringify) {
            return window.JSON.stringify(obj);
        }
        var escapable = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
            meta = {
                '\b' : '\\b',
                '\t' : '\\t',
                '\n' : '\\n',
                '\f' : '\\f',
                '\r' : '\\r',
                '"' : '\\"',
                '\\' : '\\\\'
            };

        function quote(string) {
            return '"' + string.replace(escapable, function(a) {
                var c = meta[a];
                return typeof c === "string" ? c : "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
            }) + '"';
        }

        function f(n) {
            return n < 10 ? "0" + n : n;
        }

        function str(key, holder) {
            var i,
                v,
                len,
                partial,
                value = holder[key],
                type = typeof value;

            if (value && typeof value === "object" && typeof value.toJSON === "function") {
                value = value.toJSON(key);
                type = typeof value;
            }

            switch (type) {
                case "string":
                    return quote(value);
                case "number":
                    return isFinite(value) ? String(value) : "null";
                case "boolean":
                    return String(value);
                case "object":
                    if (!value) {
                        return "null";
                    }

                    switch (Object.prototype.toString.call(value)) {
                        case "[object Date]":
                            return isFinite(value.valueOf()) ?
                                '"' + value.getUTCFullYear() + "-" + f(value.getUTCMonth() + 1) + "-" + f(value.getUTCDate()) +
                                "T" + f(value.getUTCHours()) + ":" + f(value.getUTCMinutes()) + ":" + f(value.getUTCSeconds()) + "Z" + '"' :
                                "null";
                        case "[object Array]":
                            len = value.length;
                            partial = [];
                            for (i = 0; i < len; i++) {
                                partial.push(str(i, value) || "null");
                            }

                            return "[" + partial.join(",") + "]";
                        default:
                            partial = [];
                            for (i in value) {
                                if (Object.prototype.hasOwnProperty.call(value, i)) {
                                    v = str(i, value);
                                    if (v) {
                                        partial.push(quote(i) + ":" + v);
                                    }
                                }
                            }

                            return "{" + partial.join(",") + "}";
                    }
            }
        }

        return str("", {"": obj});
    };

    Mar.getUrlParam = function() {
        var paramObj = {};
        var query = window.location.search.substring(1);
        var params;
        var pair;
        if(query) {
            params = query.split("&");
            for(var i = 0, len = params.length; i < len; i++) {
                pair = params[i].split("=");
                paramObj[pair[0]] = pair[1];
            }
        }
        return paramObj;
    };

    //用于在url没带 wapid 时，手工补全 wapid，
    Mar.getWapId = function() {
        function getMetaByName(name) {
            var meta = document.getElementsByTagName('meta');
            for (var i in meta) {
                if (typeof meta[i].name != "undefined" && meta[i].name.toLowerCase() == name) {
                    return meta[i].content;
                }
            }
            return null;
        }
        var _wapId = encodeURIComponent(getMetaByName('vip-page-default-wapid'));
        if(_wapId == 'null' || !_wapId) {
            return '';
        }
        return encodeURIComponent(_wapId);
    };

    //获取系统名称及版本号
    Mar.getOSVersion = function() {
        var ua = window.navigator.userAgent;
        var result = {
                os: '',
                ver: ''
            },
            regArr,
            uaStr,
            uaArr,
            regKey,
            regIndex;
        regArr = ua.match(/\(([^)]*)\)/);
        uaStr = regArr[1];

        function isInArray(search, array) {
            for(var i in array) {
                if(array[i]==search) {
                    return i;
                }
            }
            return -1;
        }

        if(uaStr && uaStr.match(/iPhone/i)) {
            result.os = 'IOS';
            regKey = 'OS';
        }else{
            result.os = 'Android';
            regKey = 'Android';
        }
        uaArr = uaStr.split(' ');
        regIndex = isInArray(regKey, uaArr);
        if(regIndex != -1) {
            result.ver = uaArr[++regIndex];
            result.ver = result.ver && result.ver.replace(/[_]/g, '.');
        }
        return result;
    };

    // ************* 客户端信息 **************
    var temp;

    Mar.Base = {};
    temp = Mar.Base;

    temp.local = document.location;
    temp.domain = document.domain;
    temp.docEle = document.documentElement;
    temp.context = document.compatMode.toLowerCase() === 'css1compat' ? document.body : temp.docEle;
    temp.monitor = window.screen;
    temp.href = temp.local.href;
    temp.url = escape(temp.href);
    temp.wapId = window.Mar.getWapId();
    temp.osVersion = window.Mar.getOSVersion();
    temp.paramObj = window.Mar.getUrlParam();
    temp.pn = temp.local.pathname.toLowerCase();
    temp.hn = temp.local.hostname.toLowerCase();
    temp.ref = escape(document.referrer);
    temp.cw = temp.docEle.clientWidth;
    temp.ch = temp.docEle.clientHeight;
    temp.res = temp.monitor.width + '*' + temp.monitor.height;
    temp.col = temp.monitor.colorDepth;
    temp.w = temp.context.width;
    temp.h = temp.context.height;
    temp.nav = escape(navigator.userAgent.toLowerCase());
    temp.ce = navigator.cookieEnabled ? 1 : 0;
    temp.title = escape(document.title);
}());

},{}],3:[function(require,module,exports){
/**
 * 页面性能统计<br>
 * (发送路径：/a )<br>
 * version 1.0.1.20170407<br>
 * author vk <vk.xiang@vipshop.com><br>
 * wiki <http://wiki.corp.vipshop.com/pages/viewpage.action?pageId=102827373><br>
 * @module COMMON
 * @class Mar.Performance
 * modify @20180402 Performacce 初始化执行一次，然后间隔两秒后会重新发一次请求
 * @param reInited 是否重新初始化(默认不传该参数，即视为初始化)
 */
Mar.Performance = function(reInited) {
    var pf = window.performance,
        t,
        measures,
        interval,
        isInit = reInited ? 0 : 1;
    if (pf) {
        t = pf.timing;
        // 设置页面加载初值
        //Mar.initTime = t.navigationStart;
        if(isInit) {
            interval = setInterval(function() {
                if (t.loadEventEnd !== 0) {
                    //页面 load 事件执行完成
                    clearInterval(interval);

                    measures = pfDataProcessing(pf);
                    sendData(measures, isInit);
                    setTimeout(function() {
                        Mar.Performance(isInit);
                    }, 2000);
                }
            }, 100);
        } else {
            measures = pfDataProcessing(pf);
            sendData(measures, isInit);
        }
    }
    return Mar;
};

var pfDataProcessing = function(pf) {
    var t = pf.timing,
        n = pf.navigation,
        measures;

    measures = {
        /**
         * ps_nav 页面打开耗时<br>
         * t.loadEventEnd - t.navigationStart
         * @property navigation
         * @type {number}
         */
        navigation: t.loadEventEnd - t.navigationStart,
        /**
         * ps_ule<br>
         * t.unloadEventEnd - t.unloadEventStart
         * @property unloadEvent
         * @type {number}
         */
        unloadEvent: t.unloadEventEnd - t.unloadEventStart,
        /**
         * ps_rd 重定向消耗的时间<br>
         * t.redirectEnd - t.redirectStart
         * @property redirect
         * @type {number}
         */
        redirect: t.redirectEnd - t.redirectStart,
        /**
         * 	ps_dlu 域名查找消耗的时间<br>
         * t.domainLookupEnd - t.domainLookupStart
         * @property domainLookup
         * @type {number}
         */
        domainLookup: t.domainLookupEnd - t.domainLookupStart,
        /**
         * ps_con 浏览器向服务器建立获取当前页面文档的时间<br>
         * t.connectEnd - t.connectStart
         * @property connect
         * @type {number}
         */
        connect: t.connectEnd - t.connectStart,
        /**
         * ps_req<br>
         * t.responseStart - t.requestStart
         * @property request
         * @type {number}
         */
        request: t.responseStart - t.requestStart,
        /**
         * ps_resp 服务器响应或连接结束消耗的时间<br>
         * t.responseEnd - t.responseStart
         * @property response
         * @type {number}
         */
        response: t.responseEnd - t.responseStart,
        /**
         * ps_dl 页面文档从开始下载到准备可以交互完成所消耗的时间<br>
         * t.domInteractive - t.domLoading
         * @property domLoading
         * @type {number}
         */
        domLoading: t.domInteractive - t.domLoading,
        /**
         * ps_di 页面DOM可以交互消耗的时间<br>
         * t.domContentLoadedEventEnd - t.domInteractive
         * @property domInteractive
         * @type {number}
         */
        domInteractive: t.domContentLoadedEventEnd - t.domInteractive,
        /**
         * ps_dcl 当前网页所有需要执行的脚本执行完成时的Unix毫秒时间戳 到 当前网页DOMContentLoaded事件发生时（即DOM结构解析完毕、所有脚本开始运行时）的时间戳<br>
         * t.domContentLoadedEventEnd - t.domContentLoadedEventStart
         * @property unloadEvent
         * @type {number}
         */
        domContentLoaded: t.domContentLoadedEventEnd - t.domContentLoadedEventStart,
        /**
         * ps_dc <br>
         * t.domComplete - t.domLoading
         * @property domComplete
         * @type {number}
         */
        domComplete: t.domComplete - t.domLoading,
        /**
         * ps_le  window.onload 所执行消耗的总时间<br
         * t.loadEventEnd - t.loadEventStart
         * @property loadEvent
         * @type {number}
         */
        loadEvent: t.loadEventEnd - t.loadEventStart,
        /**
         * ps_ft <br>
         *  t.responseEnd - t.fetchStart
         * @property fetch
         * @type {number}
         */
        fetch: t.responseEnd - t.fetchStart,
        /**
         * ps_ty （window.performance.navigation.type）重定向的类型<br>
         * 0：网页通过点击链接、地址栏输入、表单提交、脚本操作等方式加载;<br>
         * 1：网页通过“重新加载”按钮或者location.reload()方法加载;<br>
         * 2：网页通过“前进”或“后退”按钮加载;<br>
         * 255：任何其他来源的加载;<br>
         * @property type
         * @type {string}
         */
        type: n.type,
        /**
         * ps_ttfb TTFB 即 Time To First Byte 的意思<br>
         * t.responseStart - t.navigationStart
         * @property timeTofirstByte
         * @type {number}
         */
        timeTofirstByte: t.responseStart - t.navigationStart,
        /**
         * ps_ac  计算appcache 所消耗的时间<br
         * t.domainLookupStart - t.fetchStart
         * @property appcache
         * @type {number}
         */
        appcache: t.domainLookupStart ? t.domainLookupStart - t.fetchStart :
            (t.connectStart ? t.connectStart - t.fetchStart : t.requestStart - t.fetchStart)
    };
    /**
     * entry 获取所有资源请求的总数 <br>
     * @property entriesTotal
     * @type {number}
     */
    var entriesTotal = 0;
    /**
     * enType 获取所有资源的类型及下载总时间，如：link:{n:2,t:300}、css、img、script、xmlhttprequest、''（空字符串）...，其种n为对应类型总数，t为对应下载总耗时
     * @property initiatorType
     * @type {json}
     */
    var initiatorType = 0;
    //获取所有资源请求
    if (pf.getEntries) {
        var entry = performance.getEntries();
        var obj = {};
        for (var i = 0, len = entry.length; i < len; i++) {
            var element = entry[i];
            //资源请求的事件类型
            if (!obj[element.initiatorType] && element.initiatorType != undefined) {
                obj[element.initiatorType] = {
                    n: 1,
                    t: Math.ceil(element.duration)
                };
            } else if (obj[element.initiatorType]) {
                //类型总数
                var entryNumber = obj[element.initiatorType]['n'];
                //类型总下载时间
                var entryTime = obj[element.initiatorType]['t'];
                obj[element.initiatorType] = {
                    n: ++entryNumber,
                    t: Math.ceil(entryTime + element.duration)
                };
            }
        }
        measures.entriesTotal = entry.length;
        measures.initiatorType = Mar.stringify(obj);
    }
    return measures;
};

var sendData = function(measures, isInit) {
    Mar.Request('/a?ps_nav=' + measures.navigation +
        '&ps_ule=' + measures.unloadEvent +
        '&ps_rd=' + measures.redirect +
        '&ps_dlu=' + measures.domainLookup +
        '&ps_con=' + measures.connect +
        '&ps_req=' + measures.request +
        '&ps_resp=' + measures.response +
        '&ps_dl=' + measures.domLoading +
        '&ps_di=' + measures.domInteractive +
        '&ps_dcl=' + measures.domContentLoaded +
        '&ps_dc=' + measures.domComplete +
        '&ps_le=' + measures.loadEvent +
        '&ps_ft=' + measures.fetch +
        '&ps_ty=' + measures.type +
        '&ps_ttfb=' + measures.timeTofirstByte +
        '&ps_ac=' + measures.appcache +
        '&entry=' + measures.entriesTotal +
        '&enType=' + measures.initiatorType +
        '&isInit=' + isInit || 0
    );
};

},{}],4:[function(require,module,exports){
/**
 * 随机数生成模块<br>
 * version 1.0.1.20170407<br>
 * TODO:是否需要这么多生成随机数方法？<br>
 * author vk <vk.xiang@vipshop.com><br>
 * @module COMMON
 * @class Mar.Random
 */
Mar.Random = {
    /**
     * GUID生成方法1 <br>
     * 目前用于生成visit_id的cookie值
     * @method guid
     * @returns {string} guid 例如：2E6747FAAF9B8097BA2B9862FB53D6C2
     */
    guid: function () {
        var i = 0,
            id = [];
        while (i < 8) {
            id.push((((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1));
            i++;
        }
        return id.join("").toUpperCase();
    },
    /**
     * GUID生成方法2 <br>
     * 目前用于生成PC tab_page_id请求参数
     * @method guid2
     * @returns {string} guid 例如：d5239940-e653-12d4-bd61-ffa17bbf69d7
     */
    guid2: function () {
        function s4() {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        }

        return (s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4());
    },
    /**
     * GUID生成方法3 <br>
     * 目前用于生成WAP tab_page_id请求参数
     * @method guid3
     * @returns {string} guid 例如：c77ca5120f400001f0b8b102dc582a30
     */
    guid3: function () {
        var dg = new Date(1582, 10, 15, 0, 0, 0, 0);
        var dc = new Date();
        var t = dc.getTime() - dg.getTime();
        var tl = getIntegerBits(t, 0, 31);
        var tm = getIntegerBits(t, 32, 47);
        var thv = getIntegerBits(t, 48, 59) + '1';
        var csar = getIntegerBits(rand(4095), 0, 7);
        var csl = getIntegerBits(rand(4095), 0, 7);

        var n = getIntegerBits(rand(8191), 0, 7) +
            getIntegerBits(rand(8191), 8, 15) +
            getIntegerBits(rand(8191), 0, 7) +
            getIntegerBits(rand(8191), 8, 15) +
            getIntegerBits(rand(8191), 0, 15);
        return tl + tm + thv + csar + csl + n;

        function getIntegerBits(val, start, end) {
            var base16 = returnBase(val, 16);
            var quadArray = new Array();
            var quadString = '';
            var i = 0;
            for (i = 0; i < base16.length; i++) {
                quadArray.push(base16.substring(i, i + 1));
            }
            for (i = Math.floor(start / 4); i <= Math.floor(end / 4); i++) {
                if (!quadArray[i] || quadArray[i] == '') quadString += '0';
                else quadString += quadArray[i];
            }
            return quadString;
        };

        function returnBase(number, base) {
            return (number).toString(base);
        };
        function rand(max) {
            return Math.floor(Math.random() * (max + 1));
        };
    },
    /**
     * 生成指定长度的随机数 <br>
     * 目前用于生成mars_sid 和 mars_cid的随机数部分
     * @method rand
     * @param [len] {number} 长度 默认是32位
     * @returns {string} 随机数 例如：bb534acdd50ba1519bb4dcf534112ddc
     */
    rand: function (len) {
        var x = "0123456789abcdef",
            tmp = "",
            i = 0;
        len = len || 32;
        for (; i < len; i++) {
            tmp += x.charAt(Math.ceil(Math.random() * 100000000) % x.length);
        }
        return tmp;
    }
};
},{}],5:[function(require,module,exports){
/**
 * 工具类<br>
 * version 1.0.1.20170407<br>
 * author vk <vk.xiang@vipshop.com><br>
 * @module COMMON
 * @class Mar.Util
 */
Mar.Util = {
    /**
     * 获取浏览器信息
     * @method detect
     * @returns {{browser: *, version: *, mobile: boolean}|*} 1.浏览器 会返回MSIE, Chrome, Opera, Firefox等 2.版本信息 3.是否移动设备
     */
    detect: function() {
        var re,
            browser,
            version,
            mobile = false,
            ua = window.navigator.userAgent;
        // 判断是否为 IE 浏览器
        if (/MSIE/.test(ua)) {
            browser = 'MSIE';
            //判断是否为移动端IE
            if (/IEMobile/.test(ua)) {
                mobile = true;
            }
            version = /MSIE \d+[.]\d+/.exec(ua)[0].split(' ')[1];
        }
        //IE11判断
        else if (navigator.userAgent.match(/Trident.*rv[ :]*11\./)) {
            browser = 'MSIE';
            version = 11;
        }
        // 判断是否为 Chrome 浏览器
        else if (/Chrome/.test(ua)) {
            // Platform override for Chromebooks
            browser = 'Chrome';
            version = /Chrome\/[\d\.]+/.exec(ua)[0].split('/')[1];
        }
        // 判断是否为 Opera 浏览器
        else if (/Opera/.test(ua)) {
            browser = 'Opera';
            if (/mini/.test(ua) || /Mobile/.test(ua)) {
                mobile = true;
            }
        }
        // 判断是否为 Android 设备
        else if (/Android/.test(ua)) {
            browser = 'Android Webkit Browser';
            mobile = true;
        }
        // 判断是否为 Firefox 浏览器
        else if (/Firefox/.test(ua)) {
            browser = 'Firefox';
            if (/Fennec/.test(ua)) {
                mobile = true;
            }
            version = /Firefox\/[\.\d]+/.exec(ua)[0].split('/')[1];
        }
        // 判断是否为 Safari 浏览器
        else if (/Safari/.test(ua)) {
            browser = 'Safari';
            if ((/iPhone/.test(ua)) ||
                (/iPad/.test(ua)) ||
                (/iPod/.test(ua))) {
                mobile = true;
            }
        }
        // 未知设备
        if (!version) {
            version = /Version\/[\.\d]+/.exec(ua);
            if (version) {
                version = version[0].split('/')[1];
            } else {
                version = undefined;
            }
        }
        re = {
            browser: browser,
            version: version,
            mobile: mobile
        };
        return re;
    },
    /**
     * 是否一个dom节点
     * @param o 节点
     * @returns {boolean}
     */
    isElement: function(o) {
        if (o && (typeof HTMLElement === "function" || typeof HTMLElement === "object") && o instanceof HTMLElement) {
            return true;
        }
        return !!((o && o.nodeType && o.nodeType === 1));
    },
    /**
     * 获取URL的协议
     * @method getProtocal
     * @returns {string} https:// | http://
     */
    getProtocal: function() {
        return document.location.href.toLowerCase().indexOf("https://") !== -1 ? "https://" : "https://";
    },
    /**
     * 安全加密mars_cid
     * @method encryptCid
     * @param timestamp_mar_id [string] 时间戳+随机数 46位
     * @returns {*} 安全加密的 mars_cid
     */
    encryptCid: function(timestamp_mar_id) {
        // split mar Id
        var mar_arr = timestamp_mar_id.split("_");
        var timestamp = mar_arr[0];
        var mar_id = mar_arr[1];
        if (!timestamp || !mar_id) {
            return timestamp_mar_id;
        }

        // the sum of numbers from timestamp
        var timestamp_sum = 0;
        var timestamp_len = timestamp.length;
        for (var i = 0; i < timestamp_len; i++) {
            timestamp_sum += parseInt(timestamp[i]);
        }

        var replace_index = timestamp_sum % 32;

        // the sum of all whole numbers from timestamp_mar_id
        var dechex_sum = timestamp_sum;
        var mar_id_len = mar_id.length;
        for (var i = 0; i < mar_id_len; i++) {
            if (i !== replace_index) {
                dechex_sum += parseInt(mar_id[i], 16);
            }
        }

        var replace_value = (dechex_sum % 16).toString(16);
        return timestamp + "_" + mar_id.substr(0, replace_index) + replace_value.toString() + mar_id.substr(replace_index + 1, mar_id_len);
    },
    /**
     * 按参数名获取QueryString的值
     * @method getParameterByName
     * @param name {string} 参数名
     * @returns {*} QueryString的值，没有的时候为""
     */
    getParameterByName: function(name) {
        name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
        var regexS = "[\\?&]" + name + "=([^&#]*)";
        var regex = new RegExp(regexS);
        var results = regex.exec(window.location.search);
        if (results == null) {return "";}
        return decodeURIComponent(results[1].replace(/\+/g, " "));
    },
    /**
     * 获取MarConfig下配置变量
     * @method getConfig
     * @param key {string} MarConfig的配置key
     * @returns {*} MarConfig的配置key对应的值
     */
    getConfig: function(key) {
        if ('MarConfig' in window && !!window.MarConfig && window.MarConfig[key]) {
            return window.MarConfig[key];
        }
        return '';
    },
    /**
     * 补0
     * @method pad
     * @param num 原数字
     * @param n 位数
     * @returns {string} 补0后的数字
     */
    pad: function(num, n) {
        var len = num.toString().length;
        while (len < n) {
            num = "0" + num;
            len++;
        }
        return num;
    },
    /**
     * 根据document.domain设定mars所在的一级域名
     * @method getDomain
     * @returns {*} domain mars所在的一级域名
     */
    getDomain: function() {
        var documentDomain = document.domain.toLowerCase(),
            domain;
        if (documentDomain.indexOf('vipshop.com') !== -1) {
            domain = 'vipshop.com';
        } else if (documentDomain.indexOf('appvipshop.com') !== -1) {
            domain = 'appvipshop.com';
        } else if (documentDomain.indexOf('vipglobal.hk') !== -1) {
            domain = 'vipglobal.hk';
        } else if (documentDomain.indexOf('vpal.com') !== -1) {
            domain = 'vpal.com';
        }else if (documentDomain.indexOf('ebatong.com') !== -1) {
            domain = 'ebatong.com';
        }else {
            domain = 'vip.com';
        }
        return domain;
    },
    /**
     * 格式化url
     * @method parseURL
     * @param url {string} URL
     * @returns {{source: *, protocol: string, host: string, port: (*|Function|string), query: (*|string), params, file: *, hash: string, path: string, relative: *, segments: Array}} 格式化后的url
     */
    parseURL: function(url) {
        var a = document.createElement('a');
        a.href = url;
        return {
            source: url,
            protocol: a.protocol.replace(':', ''),
            host: a.hostname,
            port: a.port,
            query: a.search,
            params: (function() {
                var ret = {},
                    seg = a.search.replace(/^\?/, '').split('&'),
                    len = seg.length,
                    i = 0,
                    s;
                for (; i < len; i++) {
                    if (!seg[i]) {
                        continue;
                    }
                    s = seg[i].split('=');
                    ret[s[0]] = s[1];
                }
                return ret;
            }()),
            file: (a.pathname.match(/\/([^\/?#]+)$/i) || [, ''])[1],
            hash: a.hash.replace('#', ''),
            path: a.pathname.replace(/^([^\/])/, '/$1'),
            relative: (a.href.match(/tps?:\/\/[^\/]+(.+)/) || [, ''])[1],
            segments: a.pathname.replace(/^\//, '').split('/')
        };
    },
    /**
     * 获取时间戳
     * @method getTimeSpan
     * @returns {Number} 时间戳
     */
    getTimeSpan: function() {
        return parseInt(Mar.Util.getTimeSpanMillisecond() / 1000);
    },
    /**
     * 获取时间戳【毫秒级】
     * @method getTimeSpanMillisecond
     * @returns {Number} 时间戳【毫秒级】
     */
    getTimeSpanMillisecond: function() {
        return new Date().getTime();
    },
    /**
     * 返回一个包装后的函数，可以在距上一次执行后wait毫秒后再执行一次,
     * 对于一些频繁行为操作，但不需要立即执行函数有帮助，例如在滚动页面
     * 停止时wait毫秒后再执行函数。
     * @method Debounce
     * @param  {Function} func      要包装的函数
     * @param  {Number} wait      时间间隔（毫秒）
     * @param  {Boolean} [immediate] 如果为true，wait毫秒后执行函数，
     *                               并且在wait时间内不会再次调用
     * @return {Function}           包装后的函数
     */
    Debounce: function(func, wait, immediate) {
        var timeout,
            args,
            context,
            timestamp,
            result;
        var _now = Date.now || function() {
            return new Date().getTime();
        };
        var later = function() {
            var last = _now() - timestamp;

            if (last < wait && last >= 0) {
                timeout = setTimeout(later, wait - last);
            } else {
                timeout = null;
                if (!immediate) {
                    result = func.apply(context, args);
                    if (!timeout) context = args = null;
                }
            }
        };

        return function() {
            context = this;
            args = arguments;
            timestamp = _now();
            var callNow = immediate && !timeout;
            if (!timeout) timeout = setTimeout(later, wait);
            if (callNow) {
                result = func.apply(context, args);
                context = args = null;
            }

            return result;
        };
    },
    /**
     * 获取url参数
     * @method getQueryStringByName
     * @param name {string} 参数名
     * @param url {string} URL
     * @returns {*} 参数值
     */
    getQueryStringByName: function(name, url) {
        var result = url.match(new RegExp("[\?\&]" + name + "=([^\&^\#]+)", "i"));
        if (result == null || result.length < 1) {
            return "";
        }
        return result[1];
    },
    /**
     * 根据name获取meta
     * @method getMetaByName
     * @param name {string} meta name
     * @returns {*} meta content
     */
    getMetaByName: function(name) {
        var meta = document.getElementsByTagName('meta');
        for (var i in meta) {
            if (typeof meta[i].name != "undefined" && meta[i].name.toLowerCase() == name) {
                return meta[i].content;
            }
        }
        return null;
    },
    /**
     * 是否详情页
     * @method isDetailPage
     * @param url {string} URL
     * @returns {boolean} 是否详情页
     */
    isDetailPage: function(url) {
        var flag = false;
        if (url && (url.indexOf('shop.vipshop.com/detail') !== -1 || url.indexOf('www.vip.com/detail') !== -1 || url.indexOf('detail.vipglobal.hk') !== -1)) {
            flag = true;
        }
        return flag;
    }
};

},{}],6:[function(require,module,exports){
/**
 * 首焦曝光数据采集<br>
 * (发送路径：/y )<br>
 * version 1.0.1.20170407<br>
 * author kenny.yang <kenny.yang@vipshop.com><br>
 * wiki <http://wiki.corp.vipshop.com/pages/viewpage.action?pageId=168158559> <br>
 * @module PC
 * @class Mar.Banner
 */
Mar.Banner = function() {
    var startTime = +new Date;
    var first = true; //默认进入页面时，第一帧的广告要发送曝光埋点

    // 是否在可视区域内
    function isView($target) {
        var sTop = $(window).scrollTop();
        var winHeight = $(window).height();
        var halfHeight = $target.height() / 2; //展示须超过一半
        var offsetTop = $target.offset().top;
        var middle = offsetTop + halfHeight;

        if (sTop <= middle && sTop + winHeight >= middle) {
            return true;
        }
        return false;
    }

    function handleRequest(adId, adIdx, firstIn, adExpose) {
        var now = +new Date;
        var expose = '';
        if (adExpose) {
            expose = '&one=' + adExpose;
        }
        if (now - startTime > 500 || firstIn) {
            Mar.Request('/y?page=index&adv=-99_' + adId + '_' + adIdx + '_1_1' + expose);
        }
        first = false;
    }
    if ($.Listeners) {
        //接收到轮播滚动发出的消息,广告id
        $.Listeners.sub('index.switchable.ads').onsuccess(function(data) {
            /**
             * 广告帧位<br>
             * @property adIdx
             * @type {string}
             */
            var adIdx = data.adIdx + 1;
            /**
             * 广告id<br>
             * @property adId
             * @type {string}
             */
            var adId = data.adId;
            /**
             * 埋点名称<br>
             * @property adExpose
             * @type {string}
             */
            var adExpose = data.adExpose;
            var panelCls = data.panelCls;
            var onlyOneAd = data.onlyOneAd;
            var view = isView(panelCls);

            // 如果只有一张首焦，绑定滚动事件
            if (onlyOneAd) {
                $(window).on('scroll', function() {
                    var view = isView(panelCls);
                    // first 默认进入页面时，第一帧的广告要发送曝光埋点
                    if (view) {
                        handleRequest(adId, adIdx, first, adExpose);
                    }
                    startTime = +new Date;
                }).trigger('scroll');
                $.Listeners.unsub('index.switchable.ads').success();
            } else {
                if (view) {
                    handleRequest(adId, adIdx, first, adExpose);
                    startTime = +new Date;
                }
            }
        });
    }
    return Mar;
};
},{}],7:[function(require,module,exports){
/**
 * 探索号基础业务逻辑信息生成模块<br>
 * mars_cid生成逻辑请查看源代码<br>
 * version 1.0.1.20170407<br>
 * author vk <vk.xiang@vipshop.com><br>
 * @module PC
 * @class Mar.Biz
 */
(function ($) {
    // **************** PC端基础业务逻辑信息 ******************
    Mar.PageIdIndex = 0;
    Mar.PageId = Mar.PageId ? Mar.PageId + '_' + (++Mar.PageIdIndex) : ((new Date()).getTime() + '_' + Mar.Random.guid2());
    /**
     * 生成Mar.Biz
     * @method Mar.Biz
     * @returns {{cid: *, sid: (*|string), pid: *, vid: (*|string), wh: *, mvar: string, newbie: number, isLog: number, orderId: string, pageId: (string|*), vip_qe: *, vip_qt: *, vip_xe: (*|string), vip_xt: (*|string)}}
     * @constructor
     */
    Mar.Biz = function () {
        var ck = Mar.Cookie,
            g = ck.getAll,
            s = ck.set,
            d = ck.del,
            base = Mar.Base,

            isLog = 0,
            newbie = 0,
            orderId = '',//TODO 当前无法获取orderId，即探索号的sn参数

            cookies = g(),

            lid = cookies['VipLID'],
            sess = cookies['PHPSESSID'],

            cid = cookies['mars_cid'] || cookies['cookie_id'],
            pid = cookies['mars_pid'] || cookies['page_id'],
            sid = cookies['mars_sid'] || Mar.Random.rand(),
            vid = cookies['visit_id'] || Mar.Random.guid(),

            tempCid = cookies['tmp_mars_cid'],

            wh = cookies['vip_wh'],

            mvar = window.mars_var ? Mar.stringify(window.mars_var) : '-',

        // for ep platform
            vip_qe = cookies['vip_qe'],
            vip_qt = cookies['vip_qt'],
            vip_xe = window.vip_xe || '',
            vip_xt = window.vip_xt || '';



        if (lid && sess && ((unescape(lid).split('|')[0]) === sess)) {
            isLog = 1;
        }

        if (!cid && tempCid) {
            cid = tempCid;
        } else {
            if (!cid || ((cid + '').length !== 32 && (cid + '').length !== 46)) {
                // cid = Cid.creat();
                cid = Mar.Util.encryptCid(Mar.Util.pad((new Date()).getTime(),13) + '_' + Mar.Random.rand());//改变CID生成规则
                newbie = 1;
            }
        }
        pid = pid || 0;

        d('cookie_id');
        d('page_id');
        d('mars_cid');

        // 每次刷新页面都重新刷新COOKIE的过期时间
        s('mars_pid', pid, (366 * 2));
        s('mars_cid', cid, (366 * 2));
        s('mars_sid', sid, 0);
        s('visit_id', vid, (30 / 60 / 24));

        return {
            'cid': cid,
            'sid': sid,
            'pid': pid,
            'vid': vid,
            'wh': wh,
            'mvar': mvar,
            'newbie': newbie,
            'isLog': isLog,
            'orderId': orderId,
            'pageId': Mar.PageId,
            'vip_qe': vip_qe,
            'vip_qt': vip_qt,
            'vip_xe': vip_xe,
            'vip_xt': vip_xt
        };
    }

})(jQuery);

},{}],8:[function(require,module,exports){
/**
 * PC商品曝光采集<br>
 * (发送路径：/y )<br>
 * version 1.0.1.20170407<br>
 * wiki <http://wiki.corp.vipshop.com/pages/viewpage.action?pageId=205393032> <br>
 * author kenny.yang <kenny.yang@vipshop.com><br>
 * @module PC
 * @class Mar.Exposure
 */
Mar.Exposure = function() {
    var that = this;
    var channel = '',
        page = encodeURIComponent(document.title),
        pageNumber = '-99',
        timer,
        loading = false,
        date = 0,
        sead = 'active_te_resource_expose',
        platform = '',
        itemObj = {},
        itemArr = [],
        browserLength = 0,
        browserTime = 0;

    /**
     * 商品 曝光
     * @wiki http://wiki.corp.vipshop.com/pages/viewpage.action?pageId=200348206
     */
    this.Exposure._request = function() {
        var obj = {
            /**
             * 页面title<br>
             * encodeURIComponent(document.title)
             * @property page
             * @type {string}
             */
            page: page,
            /**
             * 入口类型：PC暂时无法实现<br>
             * @property entry_type
             * @type {number}
             * @default 1
             */
            entry_type: 1,
            /**
             * 入口id：目前传档期id<br>
             * @property entry_id
             * @type {string}
             * @default -99
             */
            entry_id: window.pg && window.pg.brandId || '-99',
            /**
             * 中间层mshow专题id<br>
             * @property special_id
             * @type {string}
             * @default -99
             */
            special_id: '-99',
            /**
             * 曝光数据 <br>
             * itemtyp_itemid_itemrank <br>
             * itemtyp：0-档期；1-商品；2-品购；3-专题；4-运营位；5-广告位；6-品牌位  <br>
             * itemid：档期id/商品id/专题id（中间层special_id）/广告id   <br>
             * itemrank：坑位序号 第3个楼层（模块）的第5位的格式为 3.5   <br>
             * @property item_list
             * @type {string}
             */
            item_list: itemArr.join(','),
            /**
             * 浏览总长度<br>
             * @property browse_length
             * @type {string}
             */
            browse_length: browserLength.toString(),
            /**
             * 浏览总时间（单位ms）<br>
             * @property browse_time
             * @type {string}
             */
            browse_time: browserTime.toString(),
            /**
             * 数据上报时间戳<br>
             * @property expose_time
             * @type {string}
             */
            expose_time: Mar.Util.getTimeSpan().toString(),
            /**
             * 页码<br>
             * @property pageNumber
             * @type {string}
             */
            page_number: pageNumber,
            /**
             * 平台<br>
             * app/pc/wap
             * @property platform
             * @type {string}
             */
            platform: platform
        };

        var data = Mar.stringify(obj);
        /**
         * 手工发送指定路径埋点
         * @method requestUsePath
         * @param path {String} 路径
         * @param tag {String} 元素类型
         * @param ev {String} 埋点事件
         * @param seed {String} 埋点标识
         * @param customAttr {Object} 自定义属性，如果存在，将替换window.mars_var的值
         * @param data_mars的值
         */
        Mar.Seed.requestUsePath('/y', '', '', sead, '', data);
        itemObj = {};
        itemArr = [];
        browserLength = 0;
        browserTime = 0;
    };

    this.Exposure.afterGetData = function() {
        if (itemArr.length > 10) { //最少10个数据才上报
            this._request();
        }
    };

    this.Exposure.startTimer = function() {
        var that = this;
        timer = setInterval(function() {
            if (itemArr.length > 0) {
                that._request();
            }
        }, 2000);
    };

    this.Exposure.endTimer = function() {
        clearInterval(timer);
    };

    this.Exposure.getItemByArrModule = function(arrModule, index) {
        var isPush = false,
            re = {
                key: '',
                val: ''
            },
            itmArr = [];
        channel = (channel == '') ? arrModule[0] : channel;
        if (channel == '') {
            return re;
        }
        //平台
        platform = channel;
        switch (channel) {
            case 'pc':
                switch (arrModule[1]) {
                    case 'brands': //档期
                        itmArr.push(0);
                        itmArr.push(arrModule[2] ? arrModule[2] : '');
                        itmArr.push(arrModule[3] ? arrModule[3].replace('_', '.') : ''); //组件序号_列表序号 _替换成.
                        break;
                    case 'products': //商品
                        //itemtyp_itemid_itemrank
                        itmArr.push(1);
                        itmArr.push(arrModule[2] ? arrModule[2] : '');
                        itmArr.push(arrModule[4] ? arrModule[4].replace('_', '.') : '');
                        pageNumber = arrModule[3];
                        break;
                    case 'operates': //运营位
                        itmArr.push(4);
                        itmArr.push(arrModule[2] ? arrModule[2] : '');
                        itmArr.push(arrModule[3] ? arrModule[3].replace('_', '.') : ''); //组件序号_列表序号 _替换成.
                        if (arrModule[4]) {
                            innertype = arrModule[4];
                        }
                        break;
                    case 'recommend': //推荐模块商品/品牌/档期曝光
                        itmArr.push(arrModule[2]);
                        itmArr.push(arrModule[3] ? arrModule[3] : '');
                        itmArr.push(arrModule[5] ? arrModule[5].replace('_', '.') : '');
                        itmArr.push(arrModule[6] ? arrModule[6] : '');  //sub-type: 101-档期，102-商品，103-品牌,110-按钮
                        itmArr.push(arrModule[7] ? arrModule[7] : '');
                        pageNumber = arrModule[4];
                        break;
                    default:
                        break;
                }
                break;
            default:
                break;
        }

        re.key = itmArr[1] + '&' + itmArr[2];
        re.val = itmArr.join('_');

        return re;
    };

    this.Exposure.getDataList = function(min, max) {
        var that = this;
        $('[mars_exposure_module]').each(function(index) {
            var $dom = $(this);
            var offsetTop = $dom.offset().top + $dom.height() / 2;
            if (offsetTop > min && offsetTop <= max) {
                // $dom.css('outline', '1px solid red');
                var arrModule = $dom.attr('mars_exposure_module');
                if (arrModule) {
                    arrModule = arrModule.split('|');
                    var itm = that.getItemByArrModule(arrModule, index);
                    if (itm.key != '' && itemObj[itm.key] == undefined) {
                        //未曝光数据，添加曝光数组并记录到曝光obj实现去重
                        itemObj[itm.key] = itm.val;
                        itemArr.push(itm.val);
                    }
                } else {
                    return;
                }
            }
        });
    };

    this.Exposure.getData = function(scrollTop, min, max) {
        var that = this;
        if (!loading) {
            loading = true;
            if (timer) that.endTimer();
            date = Mar.Util.getTimeSpanMillisecond();

            //当前页面是否分片曝光请求
            if ($('[mars_container_slice]').length) {
                $('[mars_container_slice]').each(function(index) {
                    var $ctDom = $(this);
                    //分片在可视区域内
                    var ctOffsetTop = $ctDom.offset().top;
                    if (ctOffsetTop + $ctDom.height() > min && ctOffsetTop <= max) {
                        that.getDataList(min, max);
                    }
                });
            } else {
                that.getDataList(min, max);
            }

            var formTo = min + '_' + max;
            browserLength = browserLength + Math.abs(this.lastTop - max);
            browserTime = browserTime + Math.abs(this.lastDate - date);
            that.afterGetData();
            that.startTimer();
            that.lastScrollTop = scrollTop;
            that.lastTop = max;
            that.lastDate = date;
            loading = false;
        }
    };

    /**
     * 获取window高度
     */
    this.Exposure.getWinHeight = function() {
        return $(window).height();
    };

    /**
     * 获取滚动高度
     */
    this.Exposure.getScroll = function() {
        if (self.pageYOffset) {
            return self.pageYOffset;
        } else if (document.documentElement && document.documentElement.scrollTop) {
            return document.documentElement.scrollTop;
        } else if (document.body) {
            return document.body.scrollTop;
        }
    };

    /**
     * 初始化曝光功能
     * 停止曝光监听
     * $(window).off('mars');
     */
    this.Exposure.init = function() {
        var that = this;

        this.lastTop = 0;
        this.lastScrollTop = this.getScroll();
        //获取时间戳【毫秒级】
        this.lastDate = Mar.Util.getTimeSpanMillisecond();

        var initTimer;
        $(window).on('scroll.mars', Mar.Util.Debounce(function() {
            initTimer && clearTimeout(initTimer);
            that.onScroll();
        }, 300));

        initTimer = setTimeout(function() {
            var scrollTop = that.getScroll();
            var max = scrollTop + that.getWinHeight();
            that.getData(scrollTop, scrollTop, max);
        }, 2000);
    };

    this.Exposure.onScroll = function() {
        var that = this;
        var scrollTop = that.getScroll(),
            min,
            max;

        if (scrollTop > this.lastScrollTop) {
            min = this.lastTop;
            max = scrollTop + this.getWinHeight();
        } else if (scrollTop < this.lastScrollTop) {
            min = scrollTop;
            max = this.lastScrollTop;
        } else {
            return;
        }
        this.getData(scrollTop, min, max);
    };

    /**
     * 手工曝光接口
     * @method request
     * @param itemList {String|Array} 曝光数据 mars_exposure_modul 属性值，多个时请以数组传入<br>
     *
     * platform|itemtyp|itemid|itemrank|itemsubtyp <br>
     * platform: app/pc/wap <br>
     * itemtyp：brands-档期；products-商品；specials-专题；operates-运营位；adverts-广告位；brandSn-品牌位； dOperates-文章   <br>
     * itemid：档期id/商品id/专题id（中间层special_id）/广告id/文章id   <br>
     * itemrank：坑位序号 第3个楼层（模块）的第5位的格式为 3.5   <br>
     * 例如：<br>
     * pc|products|12345|4|3_5 <br>
     * 是一个PC商品的曝光 <br>
     */
    this.Exposure.request = function(itemList) {
        var that = this;

        function _handler(arrModule, index) {
            var itm = that.getItemByArrModule(arrModule, index);
            if (itm.key != '' && itemObj[itm.key] == undefined) {
                //未曝光数据，添加曝光数组并记录到曝光obj实现去重
                itemObj[itm.key] = itm.val;
                itemArr.push(itm.val);
            }
        }

        if (!loading) {
            loading = true;
            if (timer) that.endTimer();
            date = Mar.Util.getTimeSpanMillisecond();
            if (typeof(itemList) == 'string') {
                _handler(itemList.split('|'), 0);
            } else {
                for (var i = 0, l = itemList.length; i < l; i++) {
                    _handler(itemList[i].split('|'), i);
                }
            }
            this.afterGetData();
            that.startTimer();
            that.lastDate = date;
            loading = false;
        }
    };

    $(document).ready(function() {
        that.Exposure.init();
    });

    this.Exposure.startTimer();

    return Mar;
};
},{}],9:[function(require,module,exports){
require('../common/mars.js');
require('../common/mars.util.js');
require('../common/mars.random.js');
require('../common/mars.cookie.js');
require('./mars.biz.pc.js');
require('./mars.request.js');
require('./mars.pv.js');
require('./mars.seed.pc.js');
require('./mars.screen.pc.js');
require('./mars.links.pc.js');
require('../common/mars.performance.js');
require('./mars.var.pc.js');
require('./mars.banner.pc.js');
require('./mars.recommend.v2.pc.js');
require('./mars.exposure.pc.js');
require('./mars.saleAttribution.pc.js');

// entrance
(function(){
    // init
    Mar.PV()
        .Report()
        .Screen()
        .Links()
        .Performance()
        .Var()
        .Banner()
        .Recommend()
        .Exposure();
    Mar.Seed.init()
    .SaleAttribution.init();
})();

},{"../common/mars.cookie.js":1,"../common/mars.js":2,"../common/mars.performance.js":3,"../common/mars.random.js":4,"../common/mars.util.js":5,"./mars.banner.pc.js":6,"./mars.biz.pc.js":7,"./mars.exposure.pc.js":8,"./mars.links.pc.js":10,"./mars.pv.js":11,"./mars.recommend.v2.pc.js":12,"./mars.request.js":13,"./mars.saleAttribution.pc.js":14,"./mars.screen.pc.js":15,"./mars.seed.pc.js":16,"./mars.var.pc.js":17}],10:[function(require,module,exports){
/**
 * 获取点击位置。<br>
 * (发送路径：/m )<br>
 * 发送的数据包括：<br>
 * mx ：被点击A标签的当前鼠标x轴<br>
 * my：被点击A标签的当前鼠标y轴<br>
 * href：被点击A标签的href<br>
 * clk_depth：当前A标签在页面中的DOM深度 （注意：IE7无法采集）<br>
 * wiki <http://wiki.corp.vipshop.com/pages/viewpage.action?pageId=169139466>
 * @module PC
 * @class Mar.Links
 */
Mar.Links = function () {
    var forClick = function (e, depth) {
        var checkAttr = $(this).hasOwnProperty('href');
        var href = checkAttr ? $(this).attr('href') : '';
        href = href ? href.replace('#', '%26') : href;
        if (depth === undefined) {
            Mar.Request('/m?mx=' + e.pageX + '&my=' + e.pageY + '&href=' + href);
        } else {
            Mar.Request('/m?mx=' + e.pageX + '&my=' + e.pageY + '&clk_depth=' + depth + '&href=' + href);
        }
    };
    $(document.body).click(function (e) {
        var depth = [],
            self = $(e.target);
        var ua = Mar.Util.detect();
        if (!(ua.browser == 'MSIE' && ua.version == '7.0')) {
            //非 IE7 才能这样采集depth
            while (self && self[0] && self[0].tagName && self[0].tagName.toLowerCase() !== 'body' && self[0].tagName.toLowerCase() !== '!') {
                // remove nodeType = 8 comment node
                if (self[0].nodeType !== 8) {
                    depth.push(self[0].tagName.toLowerCase() + (self.attr('class') === undefined ? '' : '.' + self.attr('class')) + ':' + self.prevAll(self[0].tagName).length);
                    self = self.parent();
                }
            }
        }
        forClick(e, depth.reverse().join(' '));
    });
    return Mar;
};
},{}],11:[function(require,module,exports){
/**
 * 探索号PageView模块<br>
 * (发送路径：/p )<br>
 * version 1.0.1.20170407<br>
 * author vk <vk.xiang@vipshop.com><br>
 * @module PC
 * @class Mar.PV
 * @returns {*}
 * @constructor
 */
Mar.PV = function () {
    Mar.Request('/p?1=1');
    return Mar;
}
},{}],12:[function(require,module,exports){
/**
 * 曝光数据采集。<br>
 * (发送路径：/y )<br>
 * wiki <http://wiki.corp.vipshop.com/pages/viewpage.action?pageId=169139475>
 * @module PC
 * @class Mar.Recommend
 */
Mar.Recommend = function () {
    var _window = window,
        $window = $(_window),
    //暂存数据
        data = [],
        /**
         * 横向判断,marOptions.tCjudge === true ? 每次判断 : true
         * @type { Boolean }
         */
        tCjudgeFunc = _window.marOptions && marOptions.tCjudge
            ?
            function (xMax, scrollLeft, $elem, offset) {
                var oLeft = offset.left,
                    oHalfWidth = $elem.width() / 2,
                    oCenter = oLeft + oHalfWidth;
                return xMax >= oCenter && oCenter >= scrollLeft;
            }
            :
            function () {
                return true;
            };

    /**
     * 收集数据
     * @param  { Number } start 开始时间
     * @param  { Number } end   结束时间
     */
    function pushData(start, end) {
        var sTop = $window.scrollTop(),
            sLeft = $window.scrollLeft(),
            yMax = sTop + $window.height(),
            xMax = sLeft + $window.width(),
            brands = [];

        $('[mars-exposure-module]:visible').each(function (index, elem) {
            var $this = $(elem),
                offset = $this.offset(),
                oTop = offset.top,
                oHalfHeight = $this.height() / 2,
                oMiddle = oTop + oHalfHeight;
            if (yMax >= oMiddle && oMiddle >= sTop && tCjudgeFunc(xMax, sLeft, $this, offset)) {
                brands[brands.length] = $this.attr('mars-exposure-module');
            }
        });
        if (brands.length > 0) {
            data[data.length] = {
                into_time: start,
                leave_time: end,
                sec: end - start,
                brands: brands
            }
        }
    }

    /**
     * 发送数据
     */
    function sendData() {
        var i,
            j,
            dL = data.length,
            bL,
            item,
            brands,
            mars,
            mArray,
            module,
            mName;
        if (dL === 0) return;
        for (i = 0; i < dL; i++) {
            mars = {};
            item = data[i];
            brands = item.brands;
            bL = brands.length;
            for (j = 0; j < bL; j++) {
                mArray = brands[j].split('_');
                mName = mArray[1];
                module = mars[mName] = mars[mName] || [];
                module[module.length] = {brand_id: mArray[2], brand_rank: mArray[3]};
            }

            for (i in mars) {
                Mar.Request(
                    '/y?'
                    +
                    [
                        //进入时间
                        'into_time=' + item.into_time,
                        //离开时间
                        'leave_time=' + item.leave_time,
                        //曝光时长
                        'sec=' + item.sec,
                        'brand_expose='
                        +
                        encodeURIComponent(
                            Mar.stringify({
                                //页面
                                page: mArray[0],
                                //模块
                                module: i,
                                //曝光档期
                                brands: mars[i]
                            })
                        )
                    ].join('&')
                )
            }
        }
        //清空数据
        data = [];
    }

    $(document).ready(function () {
        var startTime = +new Date;

        /**
         * 判断当前离上次滚动时间超过500ms，是则作为数据曝光
         */
        function determine() {
            var now = +new Date;
            if (now - startTime > 500) {
                pushData(startTime, now);
            }
        }

        $window
            .on('scroll', function () {
                determine();
                startTime = +new Date;
            })
            .on('unload', function () {
                determine();
                sendData();
            });

        //2秒发送一次数据
        setInterval(function () {
            sendData();
        }, 2000);

    });
    return Mar;
}


},{}],13:[function(require,module,exports){
/**
 * 探索号内部发送埋点模块<br>
 * 请勿直接使用！！！<br>
 * version 1.0.1.20170407<br>
 * author vk <vk.xiang@vipshop.com><br>
 * @module PC
 * @class Mar._Request
 */
Mar._Request = {
    /**
     * 【探索号内部使用】埋点发送 <br>
     * 替换原Mar.Request方法
     * @method send
     * @param path {string} 埋点发送路径
     * @param wap {boolean} 是否wap TODO:这个判断是否能去掉
     * @param customAttr {object} mars_var发送值 JSON格式
     * @returns {*}
     * @constructor
     */
    send: function(url, wap, customAttr) {
        var base = Mar.Base,
            biz = Mar.Biz(),
            urlDomain = Mar.Util.getDomain();
        //手动触发埋点最后带上的
        if (customAttr) {
            biz.mvar = Mar.stringify(customAttr);
        }
        url = Mar.Util.getProtocal() + 'mar.' + urlDomain +
            url +
            '&mars_cid=' + biz.cid +
            '&mars_sid=' + biz.sid +
            '&pi=' + biz.pid +
            '&mars_vid=' + biz.vid +
            '&mars_var=' + biz.mvar.replace(new RegExp('&', 'gm'),'%26') +
            '&lg=' + biz.isLog +
            '&wh=' + biz.wh +
            '&in=' + biz.newbie +
            '&sn=' + biz.orderId +
            '&url=' + base.url +
            '&sr=' + base.res +
            '&rf=' + base.ref +
            '&bw=' + base.cw +
            '&bh=' + base.ch +
            '&sc=' + base.col +
            '&bv=' + base.nav +
            '&ce=' + base.ce +
            '&vs=' +
            '&title=' + base.title +
            '&tab_page_id=' + biz.pageId +
            '&vip_qe=' + biz.vip_qe +
            '&vip_qt=' + biz.vip_qt +
            '&vip_xe=' + biz.vip_xe +
            '&vip_xt=' + biz.vip_xt
        if (wap) {
            url += '&wap_ln=' + biz.wapln +
                '&wap_vs=' + biz.wapvs +
                '&wap_pwh=' + biz.wappwh +
                '&wap_wh=' + biz.wapwh +
                '&wap_id=' + biz.wapid +
                '&wap_from=' + biz.wapfrom +
                '&cps_u=' + biz.cpsu +
                '&m_vipruid=' + biz.ruid;
        }

        url += '&r=' + Math.random();
        var img = new Image(1, 1);
        img.onload = img.onerror = img.onabort = function() {
            img.onload = img.onerror = img.onabort = null;
            img = null;
        };
        img.src = url;

        return Mar;
    }
};
//临时兼容 mars.performance.js TODO： 整体替换后可以删除
Mar.Request = Mar._Request.send;
},{}],14:[function(require,module,exports){
/**
 * 销售归因<br>
 * (发送路径：/c  )<br>
 * version 1.0.1.20170407<br>
 * wiki <http://wiki.corp.vipshop.com/pages/viewpage.action?pageId=168139555>
 * author vk <vk.xiang@vipshop.com><br>
 * @module PC
 * @class Mar.SaleAttribution
 */
Mar.SaleAttribution = {
    /**
     * 监听'cart.add.mars'事件上报 <br>
     * 发送点击埋点标识：te_buy_cart_btn <br>
     * 上报数据包括:<br>
     * brand_id 档期ID<br>
     * goods_id 商品ID<br>
     * scene_id 场景ID 具体请查看wiki <http://wiki.corp.vipshop.com/pages/viewpage.action?pageId=168139555><br>
     * @method init
     * @returns {*}
     */
    init: function () {
        if ($.Listeners) {
            //统一加入购物车埋点
            $.Listeners.sub('cart.add.mars').onsuccess(function (data) {
                if (!data) {
                    return;
                }
                Mar.Seed.request("a", "click", "te_buy_cart_btn", {
                    brand_id: data.brand_id,
                    goods_id: data.goods_id,
                    scene_id: data.scene_id
                });
            });
        }
        return Mar;
    }

}


},{}],15:[function(require,module,exports){
/**
 * 获取用户浏览屏数，采用cid位数为0的数据。<br>
 * (发送路径：/s ) <br>
 * 以页面的最大高度为分母 用户浏览器的可视高度为基准 得到当前的屏数<br>
 * 非商品详情页  每屏只捕获一次<br>
 * 商品详情页  每屏都重复捕获 并且每隔三秒发送一次请求<br>
 * 注：首屏（代码中为0屏）不会主动捕获 只有当用户从其他屏回到首屏时 才会进行捕获。因为0屏是默认一定会看到的。<br>
 * wiki <http://wiki.corp.vipshop.com/pages/viewpage.action?pageId=169139444>
 * @module PC
 * @class Mar.Screen
 */
Mar.Screen = function () {
    var biz = Mar.Biz(),
        cid = biz.cid,
        lastChar = cid.substring(cid.length - 1, cid.length),
        base, arr,
        time0, time1,
        win, width, height, sHeight, top,
        some, which, interval, timeout,
        srollHeight,
        request;

    // 抽样 以CID结尾为0 1 2 3 4的用户做为样本
    if (cid.lastIndexOf('0') !== cid.length - 1) {
        return Mar;
    }

    base = Mar.Base;
    arr = [];
    time0 = (new Date()).getTime();
    win = $(window);
    width = win.width();
    height = win.height();
    sHeight = base.context.scrollHeight;

    request = function (index, t) {
        Mar.Request('/s?psn=' + index + '&pt=' + t + '&ph=' + win.scrollTop() + '&pl=' + sHeight);
    };

    win.bind('scroll', function () {
        timeout = setTimeout(function () {
            clearTimeout(timeout);
            top = win.scrollTop();
            some = Math.ceil(top / height);

            if (top >= (((some - 1) * height) + (height * 0.2))) {
                if (base.href.indexOf('shop.vipshop.com/detail') !== -1 || base.href.indexOf('www.vip.com/detail') !== -1 || base.href.indexOf('detail.vipglobal.hk') !== -1) {
                    if (which !== some) {
                        clearInterval(interval);
                        interval = setInterval(function () {
                            request(some, 3);
                        }, 3000);
                    }
                    which = some;
                } else {
                    if ($.inArray(some, arr) === -1) {
                        time1 = (new Date()).getTime();
                        request(some, ((time1 - time0) / 1000));
                        time0 = time1;
                        arr.push(some);
                    }
                }
            }
        }, 500);
    }).bind('close', function () {
        top = win.scrollTop();
        some = Math.ceil(top / height);
        time1 = (new Date()).getTime();
        request(some, ((time1 - time0) / 1000));
    }).bind('resize', function () {
        win = $(this);
        width = win.width();
        height = win.height();
        srollHeight = base.context.scrollHeight;
    });

    return Mar;
};

},{}],16:[function(require,module,exports){
/**
 * 埋点数据采集<br>
 * (发送路径：/c )<br>
 * version 1.0.1.20170407<br>
 * author vk <vk.xiang@vipshop.com><br>
 * @module PC
 * @class Mar.Seed
 */
Mar.Seed = {
  typeEnum: {
    'inputbutton': 'button',
    'inputsubmit': 'button',
    'inputtext': 'inputText',
    'inputinput': 'inputText',
    'inputradio': 'radio',
    'inputcheckbox': 'checkbox',
    'adownload': 'download',
    'a': 'link',
    'span': 'span',
    'button': 'button'
  },
  data: {
    /**
     * 页面类型 <br>
     * 通过 MarConfig.pageType 定义传入
     * @property page_type
     * @type {String}
     * @default 'unknown'
     */
    page_type: '',
    /**
     * 当前页的page_type加上当前时间戳(window.T0)
     * @property page_id
     * @type {String}
     * @default 'unknown_{timestamp}'
     */
    page_id: ''
  },
  /**
   * 绑定页面点击埋点上报 <br>
   * 带mars_sead属性的对象的点击上报其mars_sead和data_mars属性
   * (发送路径：/b )
   * @method init
   * @returns {*}
   */
  init: function () {
    var that = this;
    this.data.page_type = Mar.Util.getConfig('pageType');
    if (this.data.page_type == '') {
      this.data.page_type = 'unknown';
    }
    this.data.page_id = this.data.page_type + '_' + window.T0;
    $('body').delegate('[mars_sead]:not(select)', 'click', function () {
      var ele = $(this);
      that._onclick(ele);
    }).delegate('select[mars_sead]', 'change', function () {
      that.request('select', 'change', $(this).attr('mars_sead'));
    }).delegate('[mars_sead_hover]', 'mouseenter', function (e) {
      var ele = $(this);
      that._onclick(ele, 'hover');
    });
    return Mar;
  },
  _onclick: function (ele, evt) {
    var tag = ele[0].tagName.toLowerCase(),
                property, tn, seedType,
                dataMars,
                dataMarsArr = [];
    evt = evt || 'click';
    if (tag === 'a') {
      property = ele.attr('href');
      seedType = this.typeEnum[tag + (property ? this._isDownload(property.toLowerCase()) : '')];
    } else {
      property = ele.attr('type');
      tn = this.typeEnum[tag + (property ? property.toLowerCase() : '')];
      seedType = tn ? tn : tag;
    }
            if(ele.attr('data_mars') != undefined){
                //itemtype|innertype|itemid|append_properties
                let dataMarsAttr = ele.attr('data_mars');
                dataMarsArr = dataMarsAttr.split('|');
                if(dataMarsArr.length) {
                    dataMars = this.handleMarsData(dataMarsArr, ele);
                }
                dataMars = JSON && JSON.stringify(dataMars);
            }
            var mvar = ''
            try{
                var vis_mvar = ele.attr('data-vis-mvar')
                if(vis_mvar){
                    mvar = JSON.parse(vis_mvar)
                    mvar = Object.assign({},window.mars_var,window.inject_mars,mvar)
                }
            }catch(e){

            }
            this.request(seedType, evt, (evt.toLowerCase() !== 'hover' ? ele.attr('mars_sead') : ele.attr('mars_sead_hover')), mvar, dataMars);
        },
        /*
         * 处理点击埋点的数据
         * @dataMarsArr: [0]itemtype | [1]innertype | [2]itemid | [3]type | [4]entry_type | [5]append_properties
        */
        handleMarsData: function(dataMarsArr, ele) {
            var res,
                $target = $(ele[0]),
                tagName,
                type,   //点击类型 这里数据的组成为：${itemtype}-${innertype} 特殊类型：X-2. 按钮，X-3，超链接
                link = '',
                posObj,
                elemXyObj;

            tagName = ele[0].tagName.toLowerCase();
            if(dataMarsArr[3]) {
                type = dataMarsArr[3];
            }
            posObj = this.getElemPosition(ele);
            if(posObj) {
                elemXyObj = {
                    x: posObj.left,
                    y: posObj.top
                };
            }
            
            res = {
                name: tagName, //点击的元素的名字
                context: dataMarsArr[2],    //如点击的是文章这里就是文章id, 商品就是商品的id.等等
                hyperlink: tagName == 'a' ? encodeURIComponent($target.attr('href')) : '',  //点击的超链接
                type: type ? type : dataMarsArr[0] + '-' + dataMarsArr[1],  //点击的类型" 这里数据的组成为：${itemtype}-${innertype}）
                entry_type: dataMarsArr[4], //entry_type可选的值为：1 表示：PMS活动、2 表示：券、3 表示：全场活动)
                append_properties: dataMarsArr[5],
                location: elemXyObj ? JSON && JSON.stringify(elemXyObj) : '',
                time: new Date().getTime()  //点击时间
            };

            return res;
  },
        //获取元素坐标
        getElemPosition: function(elem) {
            return $(elem).offset();
        },
  /**
   * 手工发送埋点 <br>
   * (发送路径：/c )
   * @method request
   * @param tag {String}  元素类型
   * @param ev {String}  埋点事件
   * @param seed {String}  埋点标识
   * @param customAttr {Object} 自定义属性，如果存在，将替换window.mars_var的值
   */
        request: function(tag, ev, seed, customAttr, dataMars) {
            this.requestUsePath('/c', tag, ev, seed, customAttr, dataMars);
  },
  /**
   * 新手工发送埋点 <br>
   * (发送路径：/c )
   * @method send
   * @param tag {String}  元素类型
   * @param ev {String}  埋点事件
   * @param seed {String}  埋点标识
   * @param {Object} data_mars的值
   */
  send: function (tag, ev, seed, dataMars) {
    this.requestUsePath('/c', tag, ev, seed, false, Mar.stringify(dataMars));
  },
  /**
   * 手工发送指定路径埋点
   * @method requestUsePath
   * @param path {String} 路径
   * @param tag {String} 元素类型
   * @param ev {String} 埋点事件
   * @param seed {String} 埋点标识
   * @param customAttr {Object} 自定义属性，如果存在，将替换window.mars_var的值
   * @param data_mars的值
   */
  requestUsePath: function (path, tag, ev, seed, customAttr, dataMars) {
    var time = (new Date()).getTime() - window.T0;
    Mar._Request.send(path + '?at=' + time + '&et=' + tag + '&ed=' + ev + '&page_type=' + this.data.page_type + '&page_id=' + this.data.page_id +
      '&one=' + encodeURIComponent(seed) + '&data_mars=' + dataMars, '', customAttr);
  },
  _isDownload: function (href) {
    if (/.*\.\w*$/.test(href)) {
      return $.inArray(href.match(/\.(\w*)$/i)[1], ['rar', 'zip', 'exe', 'doc', 'ppt', 'xls', 'docx', 'xlsx', 'pptx', 'sisx', 'apk']) !== -1 ? 'download' : '';
    }
    return '';
  }
}
//本文件被调用时对外接口 TODO 待确定删除！！！
Mar.Report = function () {
  if (window.MARS_EVENT_TYPE && window.MARS_EVENT_VALUE) {
    Mar.Seed.request(MARS_EVENT_TYPE, escape(MARS_EVENT_VALUE), '', '');
  }
  return Mar;
};
},{}],17:[function(require,module,exports){
/**
 * 库存数据采集<br>
 * (发送路径：/o )<br>
 * TODO 在列表页和www详情页采集window.mars_var，切换到detail域也应该有对应采集，可是谁在使用这个东西？<br>
 * version 1.0.1.20170407<br>
 * wiki <http://wiki.corp.vipshop.com/pages/viewpage.action?pageId=169139399> <br>
 * author vk <vk.xiang@vipshop.com><br>
 * @module PC
 * @class Mar.Var
 */

Mar.Var = function () {
    if (document.location.href.indexOf('//www.vip.com/detail-') !== -1 || document.location.href.indexOf('//list.vip.com/') !== -1 || document.location.href.indexOf('//detail.vipglobal.hk/') !== -1 || document.location.href.indexOf('//list.vipglobal.hk/') !== -1) {
        var mvar = window.mars_var ? Mar.stringify(window.mars_var) : '-',
            index = 0, varInterval,
            send = function () {
                if (index < 1) {
                    index++;
                    return;
                }
                clearInterval(varInterval);
                Mar.Request('/o?iso=1');//库存数据采集
            },
            varInterval = window.setInterval(send, 1000);
    }
    return Mar;
};

},{}]},{},[9]);
})